import moment from 'moment'
import {isArray} from 'lodash'

export const NOTES_DOMAINS = {
  CLAIMS: 'Claims',
  QUOTE: 'Quote'
}

export const NOTES_READING_MODE = {
  LONG: 'long',
  SHORT: 'short'
}

export const NOTES_MODES = {
  LIST: 'list',
  EDIT: 'edit',
  DETAIL: 'detail'
}

export const pageSizes = [10, 20, 50, 100]

export const defaultPagination = {
  currentPage: 1,
  pageSize: pageSizes[0],
  total: 0,
  nextPage: undefined,
  previousPage: undefined
}

export const ENVIRONMENTS = {
  DEFAULT: 'gen3',
  GEN_2: 'gen2',
  GEN_3: 'gen3'
}

export const componentTypes = {
  SELECT: 'ElSelect',
  DATE_RANGE: 'ElDatePicker'
}

export const componentValueGetterFunction = {
  [componentTypes.SELECT] (component) {
    if (!component.value) return component.value

    const getLabel = (value) => component.options.find(option => option.value === value).label

    // For multiple selections
    if (isArray(component.value)) {
      return component.value.map(
        value => getLabel(value)
      ).join(', ')
    }
    // For single selection
    return getLabel(component.value)
  },
  [componentTypes.DATE_RANGE] (component) {
    const value = component.value
    if (!value) return value
    const getFormattedDate = date => moment(date).format('YYYY/MM/DD')
    return `${getFormattedDate(value[0])} - ${getFormattedDate(value[1])}`
  }
}
